import { useContext } from 'react';

import { type AbTastyCampaign, getAbTastyCampaigns } from '../ab-tasty';
import { AbTastyContext } from '../ab-tasty-context';

export const useAbTastyTests = (): AbTastyCampaign[] => {
  const abTastyTests = useContext(AbTastyContext);
  return getAbTastyCampaigns(abTastyTests);
};
